const ParlayWrittenTemplate = `
  <h2 id="goals-title">Learning Goals</h2>
  <p id="goals-text">
    In this RoundTable, we will discuss _______. We will build on, challenge and question each other's ideas in a respectful manner.
  </p>
  <h2 id="multimedia-title">Content & Multimedia</h2>
  <p id="multimedia-text">
    First, review the following resources:
  </p>
  <ul id="questions">
    <li>[Article/Video/Resource]</li>
  </ul> 
  <h2 id="questions-title">Discussion Questions</h2>
  <p id="questions-text">
    Now it’s time to share your thoughts! Answer the discussion questions below:
  </p>
  <ol id="questions">
    <li>[Question]</li>
    <li>[Question]</li>
  </ol>
  <p>If this subject really interests you, please feel free to do some additional research and include it in your submission. Don't worry about being “right”. The point of this discussion is to explore these ideas together.</p> 
  <h2 id="instructions-title">Peer Feedback Instructions</h2>
  <p id="instructions-text">
    After you submit your response, read through your peers’ ideas and then build on, challenge and question each other’s ideas.
  </p>
  <ul id="peer-questions">
    <li>Did they change your perspective in any way?</li>
    <li>Do you agree or disagree? Why or why not?</li>
    <li>Can you build on their ideas?</li>
  </ul> 
`;

export { ParlayWrittenTemplate };


// WEBPACK FOOTER //
// ./src/app/features/dashboard/NewRoundTable/Templates/WrittenTemplate.js